import React from 'react';
import './Stepper.css';
import { PiCheckFatFill } from 'react-icons/pi';

export default function Stepper({ steps = [], activeStep = 0, className }) {
	if (!steps.every((s) => s.counter && s.name)) {
		return null;
	}

	return (
		<div className={['stepper-wrapper', className].filter(Boolean).join(' ')}>
			{steps.map(({ counter, name }) => {
				const isCompleted = counter < activeStep;
				const isActive = counter === activeStep;
				const itemClass = ['stepper-item', isCompleted ? 'completed' : '', isActive ? 'active' : '']
					.filter(Boolean)
					.join(' ');
				return (
					<div key={counter} className={itemClass}>
						<div className='step-counter'>
							{isCompleted ? (
								<PiCheckFatFill />
							) : isActive ? (
								<div className='step-circle'></div>
							) : null}
						</div>
						<div className='step-name'>{name}</div>
					</div>
				);
			})}
		</div>
	);
}
